// src/utils/analyzeResume.js
import apiConfig from "./apiConfig";

const BACKEND_URL = apiConfig.BACKEND_URL;

export async function analyzeResume(resumeText, jobDescription) {
  const response = await fetch(`${BACKEND_URL}/analyze`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ resumeText, jobDescription }),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || "Analysis failed. Please try again.");
  }

  const data = await response.json();

  // Normalize response to handle variations in Gemini output
  return {
    ats_score: data.ats_score || data.atsScore || data.score || 0,
    match_rate: data.match_rate || data.matchRate || data.match || 0,
    missing_count: data.missing_count || data.missingCount || (data.missing_keywords || []).length || 0,
    summary: data.summary || data.overall_summary || data.overview || "",
    present_keywords: data.present_keywords || data.presentKeywords || data.found_keywords || data.keywords_found || [],
    missing_keywords: data.missing_keywords || data.missingKeywords || data.keywords_missing || [],
    sections: normalizeSections(data.sections || data.section_feedback || data.sectionFeedback || []),
    rewrites: normalizeRewrites(data.rewrites || data.suggested_rewrites || data.rewrite_suggestions || []),
    top_recommendations: data.top_recommendations || data.recommendations || data.topRecommendations || [],
  };
}

function normalizeSections(sections) {
  if (!Array.isArray(sections)) return [];
  return sections.map(s => ({
    name: s.name || s.section || s.title || "Section",
    score: normalizeScore(s.score || s.rating || s.grade || "Fair"),
    feedback: s.feedback || s.comment || s.suggestion || s.description || "",
  }));
}

function normalizeScore(score) {
  if (!score) return "Fair";
  const s = score.toString().toLowerCase();
  if (s.includes("good") || s.includes("excellent") || s.includes("strong")) return "Good";
  if (s.includes("needs") || s.includes("poor") || s.includes("weak") || s.includes("low")) return "Needs Work";
  return "Fair";
}

function normalizeRewrites(rewrites) {
  if (!Array.isArray(rewrites)) return [];
  return rewrites.map(r => ({
    section: r.section || r.category || "",
    before: r.before || r.original || r.current || "",
    after: r.after || r.improved || r.suggested || r.rewritten || "",
  }));
}